import { BlogGalleryPost, TBlogGalleryPost } from './blog-gallery-post';

export const BlogGallery = ({ items }: { items: TBlogGalleryPost[] }) => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
    {items.map((item, index) => (
      <BlogGalleryPost key={item.title} {...item} featured={index === 0} allowTwoLineTitle={index === 1} />
    ))}
  </div>
);
